/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientDetailsSubmissionRequest
 */
export interface ClientDetailsSubmissionRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientDetailsSubmissionRequest
     */
    companyName: string;
    /**
     * 
     * @type {string}
     * @memberof ClientDetailsSubmissionRequest
     */
    firstname: string;
    /**
     * 
     * @type {string}
     * @memberof ClientDetailsSubmissionRequest
     */
    lastname: string;
    /**
     * 
     * @type {string}
     * @memberof ClientDetailsSubmissionRequest
     */
    workEmail: string;
    /**
     * 
     * @type {string}
     * @memberof ClientDetailsSubmissionRequest
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof ClientDetailsSubmissionRequest
     */
    phone?: string;
}

/**
 * Check if a given object implements the ClientDetailsSubmissionRequest interface.
 */
export function instanceOfClientDetailsSubmissionRequest(value: object): value is ClientDetailsSubmissionRequest {
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('firstname' in value) || value['firstname'] === undefined) return false;
    if (!('lastname' in value) || value['lastname'] === undefined) return false;
    if (!('workEmail' in value) || value['workEmail'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    return true;
}

export function ClientDetailsSubmissionRequestFromJSON(json: any): ClientDetailsSubmissionRequest {
    return ClientDetailsSubmissionRequestFromJSONTyped(json, false);
}

export function ClientDetailsSubmissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientDetailsSubmissionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'companyName': json['companyName'],
        'firstname': json['firstname'],
        'lastname': json['lastname'],
        'workEmail': json['workEmail'],
        'country': json['country'],
        'phone': json['phone'] == null ? undefined : json['phone'],
    };
}

export function ClientDetailsSubmissionRequestToJSON(value?: ClientDetailsSubmissionRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'companyName': value['companyName'],
        'firstname': value['firstname'],
        'lastname': value['lastname'],
        'workEmail': value['workEmail'],
        'country': value['country'],
        'phone': value['phone'],
    };
}

